/*------------------------------------*\
    CART DRAWER

    Drawer-specific JS — in-drawer qty / remove handlers, plus the
    open/refresh API external callers (the ATC success handler in
    _woocommerce.js) use to swap the body and open the drawer after
    a server-side cart change.

    Universal popover infrastructure (aria-expanded sync,
    focusFirstInside on open, opener tracking + focus restore on close)
    lives in _menu-control.js, which wires all [popover][id] elements
    — including this drawer — automatically.

    Wire via data-module="camcom-cart-drawer" on the <aside popover>
    container (camcom.js dispatches via the alias map).
\*------------------------------------*/

(function ($) {

    $.fn.camcomCartDrawer = function () {

        var $drawer = $(this),
            $body   = $drawer.find('#cart-drawer__body');

        function nonce() {

            var inline = $drawer.find('.cart-drawer__items').data('cart-nonce');

            return inline || (window.ajax_variables && window.ajax_variables.cart_nonce) || '';

        }

        function refresh(bodyHtml) {

            $body.html(bodyHtml);

        }

        // The badge and the basket control's aria-label carry the same number,
        // so both are set together — header.php prints them the same way.
        function updateCount(count) {

            count = parseInt(count, 10) || 0;

            $('.site-head__actions__basket__count').text(count);
            $('.site-head__actions__basket').attr('aria-label', 'Basket, ' + count + ' items');

        }

        // cart.js updates the basket page in place and fragments are off, so
        // the header would keep its page-load count. The redrawn cart form
        // carries the live count (camcom_cart_contents_count_marker()); an
        // emptied basket has no form left, so it gets its own event.
        $(document.body).on('updated_wc_div', function () {

            var count = $('.woocommerce-cart-form [data-cart-contents-count]').attr('data-cart-contents-count');

            if (typeof count === 'string') {
                updateCount(count);
            }

        });

        $(document.body).on('wc_cart_emptied', function () {

            updateCount(0);

        });

        function open() {

            var el = $drawer.get(0);

            if (el && typeof el.showPopover === 'function') {

                try { el.showPopover(); }
                catch (e) { /* already open or browser unsupported — silent */ }

            }

        }

        // ── The shopper's own basket on a stored page ────────────────────
        // A page the cache can store is printed with an empty basket for
        // everybody (data-basket-by-script on the drawer — header.php,
        // camcom_basket_drawn_by_script()). WooCommerce's two basket cookies
        // say whether THIS visitor has one, and which: the last reply is kept
        // for the tab, keyed by the basket's hash, so the count is right at
        // once on the next page and the server is asked again only when the
        // basket has changed (or the kept copy is old enough for its nonce to
        // be going stale).
        var STORE   = 'camcom_basket',
            MAX_AGE = 6 * 60 * 60 * 1000;

        function cookie(name) {

            var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));

            return m ? m[1] : '';

        }

        function keep(data) {

            try {

                if (!data.count) {
                    window.sessionStorage.removeItem(STORE);
                    return;
                }

                window.sessionStorage.setItem(STORE, JSON.stringify({
                    hash:      cookie('woocommerce_cart_hash'),
                    at:        Date.now(),
                    count:     data.count,
                    body_html: data.body_html
                }));

            } catch (e) { /* storage off or full — the next page asks again */ }

        }

        function kept() {

            try {

                var data = JSON.parse(window.sessionStorage.getItem(STORE) || 'null');

                if (data && data.hash && data.hash === cookie('woocommerce_cart_hash') && Date.now() - data.at < MAX_AGE) {
                    return data;
                }

            } catch (e) { /* unreadable — ask the server */ }

            return null;

        }

        function fillFromShopper() {

            if (!$drawer.is('[data-basket-by-script]') || !cookie('woocommerce_items_in_cart')) {
                return;
            }

            var data = kept();

            if (data) {

                refresh(data.body_html);
                updateCount(data.count);

                return;

            }

            $.ajax({
                url:      ajax_variables.ajax_url,
                method:   'GET',
                dataType: 'json',
                cache:    false,
                data:     { action: 'camcom_cart_drawer' },
                success:  applyResponse
            });

        }

        // Single canonical applier — every server response runs through this.
        // External callers (the ATC handler) can call open() afterward to make
        // the drawer visible; in-drawer interactions skip the open call since
        // the drawer is already open.
        function applyResponse(data) {

            if (!data || !data.ok) {

                if (data && data.notices_html) {

                    // Surface WC notices into the drawer body so the user sees
                    // what failed without a page reload.
                    $body.prepend(data.notices_html);

                }

                return;

            }

            refresh(data.body_html);
            updateCount(data.count);
            keep(data);

        }

        function ajaxCartAction(action, extraData) {

            $.ajax({
                url:      ajax_variables.ajax_url,
                method:   'POST',
                dataType: 'json',
                data: $.extend({
                    action: action,
                    nonce:  nonce()
                }, extraData),
                success: applyResponse
            });

        }

        // ── In-drawer qty +/- ────────────────────────────────────────────
        $drawer.on('click', '[data-cart-qty-step]', function () {

            var $btn  = $(this),
                $item = $btn.closest('.cart-drawer__item'),
                step  = parseInt($btn.attr('data-cart-qty-step'), 10) || 0,
                key   = $item.attr('data-cart-item-key'),
                curr  = parseInt($item.find('.cart-drawer__item__qty__value').text(), 10) || 0,
                next  = Math.max(0, curr + step);

            if (!key || next === curr) { return; }

            ajaxCartAction('camcom_update_cart_qty', {
                cart_item_key: key,
                quantity:      next
            });

        });

        // ── In-drawer remove ─────────────────────────────────────────────
        $drawer.on('click', '[data-cart-remove]', function () {

            var $item = $(this).closest('.cart-drawer__item'),
                key   = $item.attr('data-cart-item-key');

            if (!key) { return; }

            ajaxCartAction('camcom_remove_from_cart', {
                cart_item_key: key
            });

        });

        fillFromShopper();

        // Public API for external callers (ATC success handler).
        $drawer.data('camcomCartDrawer', {
            drawerOpen:    open,
            drawerRefresh: refresh,
            applyResponse: applyResponse
        });

        return $drawer;

    };

}(jQuery));
